import { randomUUID } from '@/src/common/utils/randomUUID'
import { useMemo, type ComponentProps } from 'react'
import Svg, { Path, Filter, FeColorMatrix, Defs } from 'react-native-svg'

const Cashback = (props: ComponentProps<typeof Svg> & { grayscale?: boolean }) => {
  const uniqueId = useMemo(() => randomUUID(), [])
  const filterId = `grayscale-${uniqueId}`
  const grayscale = props.grayscale ? `url(#${filterId})` : undefined

  return (
    <Svg width={63} height={63} viewBox="0 0 63 63" fill="none" {...props}>
      <Defs>
        <Filter id={filterId}>
          <FeColorMatrix type="saturate" values="0" />
        </Filter>
      </Defs>
      <Path
        d="M0 8a8 8 0 018-8h47a8 8 0 018 8v47a8 8 0 01-8 8H8a8 8 0 01-8-8V8z"
        fill="#C6FFF5"
        filter={grayscale}
      />
      <Path
        d="M29.88 36.294h3.196a3.196 3.196 0 100-6.392h-4.793c-.959 0-1.758.32-2.237.959l-8.948 8.628"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={grayscale}
      />
      <Path
        d="M23.49 45.88l2.556-2.236c.48-.64 1.278-.959 2.237-.959h6.391c1.758 0 3.356-.64 4.474-1.918l7.35-7.03a3.198 3.198 0 10-4.394-4.65l-6.71 6.232M15.5 37.891l9.587 9.587"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={grayscale}
      />
      <Path
        d="M37.87 31.34a4.634 4.634 0 100-9.267 4.634 4.634 0 000 9.267zM21.891 25.109a4.794 4.794 0 100-9.588 4.794 4.794 0 000 9.588z"
        fill="#00DFC9"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={grayscale}
      />
    </Svg>
  )
}

export default Cashback
